import { render, staticRenderFns } from "./EligibleStaffTable.vue?vue&type=template&id=2b682c18&scoped=true&lang=pug&"
import script from "./EligibleStaffTable.vue?vue&type=script&lang=js&"
export * from "./EligibleStaffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b682c18",
  null
  
)

export default component.exports